export const ADD_CART = "ADD_CART"
export const REMOVE_CART = "REMOVE_CART"
export const ADJ_QTY="ADJUST_QUANTITY"
export const CLEAR="CLEAR"

